<style lang="scss" src='./SensorLogs.scss' scoped></style>
<template src="./SensorLogs.html"></template>

<script>
import moment from 'moment';
import { getSensorLogs } from '@/api/index';

export default {
  name: 'SensorLogs',
  props: {
    sensor: {
      required: false,
    },
  },
  data() {
    return ({
      sensorLogs: [],
      logsGrouped: [],
      pagination: {
        sensorLogs: {
          page: 0,
          limit: 300,
          next: null
        }
      },
      loading: {
          sensorLogs: false,
        },
    });
  },
  computed: {
  },
  watch: {
    sensor: function (newSensor, oldSensor) {
      if (newSensor && oldSensor && newSensor.sensor_id !== oldSensor.sensor_id) {
        this.loadData();
      }
    }
  },

  methods: {

    groupLogsByRequestId() {
      if ( !this.G_isEmptyArr(this.sensorLogs)) {
        let logs = "";
        
        this.sensorLogs.forEach(log => {
          const logGrouped = this.logsGrouped.find(lGrouped => log.payload.requestid === lGrouped.requestid);
          if (logGrouped) {
            logGrouped.logList.push(log);
          }else {
            this.logsGrouped.push({
              requestid: log.payload.requestid,
              logList: [log]
            });
          }
        });

        this.processLogs();
      }
    },

    processLogs() {
      let logs = "";
      this.logsGrouped.forEach(logGrouped => {
        if ( !this.G_isEmptyArr(logGrouped.logList)) {
          const logList = logGrouped.logList;
          logList.forEach(log => {
            let line = log.payload.log;
            logs = `${line}${logs}`; 
          });

          logs = logs.split('\n').reverse().join('');
          if (logs.includes("|")) {
            let expresion = /\w{8}\|/mg;
            let dates = logs.match(expresion);
            if (! this.G_isEmptyArr(dates)) {
              dates.forEach((dateExa) => {
                try {
                  let date = dateExa.replace("|", "");
                  date = (parseInt(`0x${date}`) * 1000);

                  date = moment(date).format("YYYY-MM-DD, h:mm:ss"); // This is the only place where we use this date format
                  logs = logs.replace(dateExa, `${date}    `);
                } catch (error) {}
              });
            }
          }

          logs = logs.replace(/(?:\r\n|\r|\n)/g, '<br>');
          logs = logs.replace(/ /g, '&nbsp;');
        }
        logGrouped.logTxt = logs;
      });

    },

    nextSensorLogsPage() {
      this.loadSensorLogs();
    },

    resetSensorLogsPagination() {
      this.pagination = {...this.pagination, sensorLogs: {
        ...this.pagination.sensorLogs,
        next: null,
        page: 0
      }};
    },

    async loadSensorLogs() {
      this.loading.sensorLogs = true;

      let pagination = this.pagination.sensorLogs;
      await getSensorLogs(this.sensor.serial_number, {
        limit: pagination.limit,
        next: pagination.next
      }).then((response) => {
        this.pagination.sensorLogs = {
          ... this.pagination.sensorLogs,
          next: response.next_page,
          page: ((response.rows && response.rows.length) ?
            this.pagination.sensorLogs.page + 1 : this.pagination.sensorLogs.page)
        };

        if (this.pagination.sensorLogs.page > 1) {
          this.sensorLogs = [...this.sensorLogs, ...response.rows];
        } else {
          this.sensorLogs = response.rows;
        }
        
        this.groupLogsByRequestId();
        this.loading.sensorLogs = false;
      });
    },

    downloadLogsAsTxt() {
      let logTxt = "";
      this.logsGrouped.forEach(logGrouped => {
        let log = logGrouped.logTxt.replace(/<br>/g, '\n');
        log = log.replace(/&nbsp;/g, ' ');
        logTxt += (
                    `--- ${logGrouped.requestid} --------------------------------------\n
                    ${log}\n`
                  );
      })
      
      var a = document.getElementById("btnDownloadSensorLogs");
      var file = new Blob([logTxt], {type: 'text/plain'});
      a.href = URL.createObjectURL(file);
      a.download = `${this.sensor.serial_number}.log`;
    },

    loadData() {
      this.sensorLogs = [];
      this.logsGrouped = [],
      this.resetSensorLogsPagination();
      if (this.sensor){
        this.loadSensorLogs();
      }
    },
  },

  beforeCreate() {},

  created() {},

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Sensors Logs");
      this.$analytics.logEvent("web_sensors_logs");
    }

    this.loadData();
  },
};
</script>
